
import { SuggestResult } from './Autocomplete';
import {SrcType} from "@t/meta/SourceType";

export const MENTION_CHAR = "@";

export class MentionObject {
	public element: Element;
	//public srcId?: string;
	public position: number;
	
	constructor(cursorPosition?: number) {
		this.element = document.createElement("span");
		this.element.classList.add("mention");
		this.element.classList.add("mentionNotFound");
		this.element.innerText=MENTION_CHAR;
		
		this.position = cursorPosition?cursorPosition:0;
	}
	
	public updateWithResult(result: SuggestResult): void {
		const txt = MENTION_CHAR+result.key;
		this.element.innerText=txt;
		this.element.setAttribute('data-mention', result.spec);
		this.element.classList.remove("mentionNotFound");
		this.element.classList.add("mentionFound");
		this.element.setAttribute('contentEditable', "false");
		this.element.setAttribute('v-preview', "previewKey("+SrcType.PARTY+","+result.spec+")");
		this.position = this.position+txt.length;
		//this.srcId = result.spec;		
		//console.log("actual pos:"+this.position);
	}
	
	public removeClasses(): void {
		this.element.removeAttribute("class");
	}
}
